import { Utils } from "@/plugins/utils"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstfn9: [],
		fn9: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 100,
		search: "",
		isLiquidation: false,
		liquidationSide: "",
		hasNext: false,
		lastUpdatedRegister: null,
		fn9returned: false,
		sinceDate: moment().format("YYYY-MM-DD 00:00"),
		untilDate: moment().add(6, "months").format("YYYY-MM-DD 23:59"),
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getfn9(state) {
			let fn9 = { ...state.fn9 }
			return fn9
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, fn9) {
			state.fn9 = fn9
			if (fn9) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fn9 = null
		},
		setParamsDataTable(state, payload) {
			state.lstfn9 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setfn9(state, fn9) {
			state.fn9 = fn9
		},
		setLstfn9(state, lstfn9) {
			state.lstfn9 = lstfn9
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
		setLiquidationState(state, value) {
			state.isLiquidation = value
		},
		setLiquidationSide(state, side) {
			state.liquidationSide = side || ""
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let url = `/Financial/Check/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`
			if (state.sinceDate) {
				url += `&since=${state.sinceDate}`
			}
			if (state.untilDate) {
				url += `&until=${state.untilDate}`
			} 
			if (state.fn9proprio != null) {
				url += `&fn9proprio=${state.fn9proprio}`
			} 

			if (state.fn9valor) {
				url += `&fn9valor=${state.fn9valor}`
			} 

			if (state.fn9cmc7) {
				url += `&fn9cmc7=${state.fn9cmc7}`
			} 
			if (state.fn9inuse != null) {
				url += `&fn9inuse=${state.fn9inuse}`
			} 
			if (state.isLiquidation != null) {
				url += `&isLiquidation=${state.isLiquidation}`
			} 
			if (state.liquidationSide) {
				url += `&liquidationSide=${state.liquidationSide}`
			}
			if (state.fn9returned != null) {
				url += `&fn9returned=${state.fn9returned}`
			} 
			let payload = await this._vm.$axios
				.get(url)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstfn9", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch }, {fn9doc, fn9banco, fn9agencia, fn9compens, fn9cheque, fn9conta}) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/Check/Find/${fn9doc}/${fn9banco}/${fn9agencia}/${fn9compens}/${fn9cheque}/${fn9conta}`)
				.then(response => {
					let fn9 = Utils.ValidateAxiosResponse(response.data)
					commit("set", fn9)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				
			commit("setLoading", false)
		},		
		async save({ getters, dispatch, state }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}else{
				return await dispatch("insert")
			}
			
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Financial/Check/Insert", getters.getfn9)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setfn9", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Financial/Check/Update", getters.getfn9)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }, fn9) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Financial/Check/Delete/${fn9.fn9doc}/${fn9.fn9banco}/${fn9.fn9agencia}/${fn9.fn9compens}/${fn9.fn9cheque}/${fn9.fn9conta}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
